import React, { useEffect, useState } from 'react';
import { format, startOfMonth, endOfMonth } from 'date-fns';

import './MonthSelector.scss';
const MonthSelector = ({ onMonthChange, inputProps = {} }) => {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`; // Format YYYY-MM
  });

  const getDateRange = (selectedMonth) => {
    const [year, month] = selectedMonth.split('-').map(Number);
    const selectedDate = new Date(year, month - 1);
    return {
      startDate: format(startOfMonth(selectedDate), 'yyyy-MM-dd'),
      endDate: format(endOfMonth(selectedDate), 'yyyy-MM-dd'),
    };
  };

  useEffect(() => {
    const dateRange = getDateRange(selectedMonth);
    onMonthChange(dateRange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMonthChange = (event) => {
    const newMonth = event.target.value;
    if (newMonth === '') return;

    setSelectedMonth(newMonth);

    const dateRange = getDateRange(newMonth);
    onMonthChange(dateRange);
  };

  const currentYear = new Date().getFullYear();
  const minDate = `${currentYear - 1}-01`;
  const maxDate = `${currentYear + 3}-12`;

  return (
    <div className="filter-month-selection">
      <label htmlFor="month-select">Select Month</label>
      <input id='month-select' type="month" value={selectedMonth} onChange={handleMonthChange} min={minDate} max={maxDate} {...inputProps}/>
    </div>
  );
};

export default MonthSelector;